import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=7123b095&scoped=true"
import script from "./resetpwd.vue?vue&type=script&lang=js"
export * from "./resetpwd.vue?vue&type=script&lang=js"
import style0 from "./resetpwd.vue?vue&type=style&index=0&id=7123b095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7123b095",
  null
  
)

export default component.exports